import { useEffect } from 'react';
import { MapContainer, TileLayer, useMap } from 'react-leaflet';
import { LatLngBoundsExpression, Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix for default marker icon in Leaflet with bundlers
// @ts-expect-error - Leaflet icon fix
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl:
    'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
});

/**
 * Component to update map bounds when they change
 */
function BoundsUpdater({ bounds }: { bounds: LatLngBoundsExpression }) {
  const map = useMap();

  useEffect(() => {
    if (bounds) {
      map.fitBounds(bounds, { padding: [5, 5] });
    }
  }, [map, bounds]);

  return null;
}

interface WorkorderMapBaseProps {
  /**
   * Map bounds to fit
   */
  bounds: LatLngBoundsExpression;
  /**
   * Additional CSS classes
   */
  className?: string;
  /**
   * Enable scroll wheel zoom
   * @default false
   */
  scrollWheelZoom?: boolean;
  /**
   * Map children (markers, polylines, etc.)
   */
  children: React.ReactNode;
  /**
   * Minimum height for the map container
   * @default '200px'
   */
  minHeight?: string;
}

/**
 * Base map component with TileLayer and bounds handling
 * Provides foundation for all workorder map views
 */
export function WorkorderMapBase({
  bounds,
  className = '',
  scrollWheelZoom = false,
  children,
  // minHeight = '200px',
}: WorkorderMapBaseProps) {
  return (
    <MapContainer
      bounds={bounds}
      boundsOptions={{ padding: [5, 5] }}
      className={`${className} rounded-lg border`}
      scrollWheelZoom={scrollWheelZoom}
      aria-label="Interactive map showing workorder locations and routes"
      // style={{ minHeight }}
    >
      <BoundsUpdater bounds={bounds} />
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
      />
      {children}
    </MapContainer>
  );
}
